<template>
    <div class="desktop-only contained-anchor" v-if="packages || contacts">
        <a href="#" @click.prevent="toggle()" class="text-white text-base desktop-only"><i class="fas fa-plus"></i></a>
        <div class="create-dropdown" v-if="open">
          <a v-if="contacts" href="#" @click.prevent="createContact()"><i class="fa fa-user"></i> New Contact</a>
          <a v-if="contacts" href="#" @click.prevent="createCompany()"><i class="fa fa-building"></i> New Company</a>
          <a v-if="packages" href="#" @click.prevent="createProject()"><i class="fas fa-folder-open"></i> New
            Project</a>
          <a v-if="packages" href="#" @click.prevent="createPackage()"><i class="fas fa-warehouse-alt"></i> New Package</a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: ['packages','contacts'],
        data() {
            return {
                open: false
            }
        },
        filters: {},
        watch: {},
        computed: {},
        methods: {
          toggle: function () {
            this.open = !this.open;
          },
          create: function (type) {
            eventBus.$emit('create-widget-create', type);
          },
          createContact() {
            window.eventBus.$emit('create-new-contact');
            this.open = false;
          },
          createProject() {
            window.eventBus.$emit('create-new-project');
            this.open = false;
          },
          createPackage() {
            window.eventBus.$emit('create-new-package');
            this.open = false;
          },
          createCompany() {
            window.eventBus.$emit('create-new-company');
            this.open = false;
          },
        },
        mounted() {
            var that = this;

            window.eventBus.$on('create-widget-create', function (type) {
                that.open = false;
            });

        }
    }
</script>

<style lang="scss" scoped>
    /*SASS Goes Here*/
    @import '../../sass/setup';

    .contained-anchor {
        position: relative;
    }

    .create-dropdown {
        width: 200px;
        position: absolute;
        right: 14px;
        top: 44px;
        background-color: #fff;
        border-radius: 0 0 $standardBorderRadius $standardBorderRadius;
        padding: 1em;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        z-index: 100;
        a {
            padding-top: 0.5em !important;
            padding-bottom: 0.5em !important;
            padding-left:0.5em !important;
            padding-right:0.5em !important;
            display: block;
            color: $brand !important;
            font-weight: 500;
            border-radius:$standardBorderRadius;
            &:hover{
                background-color:#d9f1ff;
            }
        }
    }
</style>
